import React from 'react';
import { Button } from 'reactstrap';

import history from '../../utils/history';
import {
  formatAccuracy,
  formatNumber,
  formatTime,
} from '../../utils/numberFormatter';

class Daily20Quiz extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      correct: 10,
      correctPoints: 32,
      accuracy: 0,
      accuracyPoins: 5,
      timeElapsed: 1900,
      timeElapsedPoins: 4,
    };
  }

  exitQuiz = () => {
    history.push('/app/daily-quiz');
    this.props.setDailyQuiz(null);
    this.props.checkDailyQuizStatus();
  };

  reviewAnswers = () => {
    history.push('/app/daily20quizReview');
  };

  componentDidMount() {
    const accuracy = (this.state.correct / 20) * 100;
    this.setState({ accuracy });
  }

  UNSAFE_componentWillMount() {
    if (!this.props.quiz) {
      this.props.setDailyTimeOut(false);
      history.push('/app/daily20quizReview');
    }
  }

  componentWillUnmount() {
    this.props.setDailyTimeOut(false);
  }

  render() {
    const quiz = this.props.quiz;
    let resultsSummarized = null;
    if (quiz && typeof quiz.resultsSummarized === 'string') {
      resultsSummarized = JSON.parse(quiz.resultsSummarized);
    } else if (quiz && typeof quiz.resultsSummarized === 'object') {
      resultsSummarized = quiz.resultsSummarized;
    }

    return (
      <div className="question-main-body daily20quizresults">
        <div className="question-background">
          <div className="question-wrapper">
            <h4>Daily 20 Quiz</h4>
            <h2>Your Results</h2>
          </div>
        </div>
        <div className="gradient-divider" />
        {quiz && resultsSummarized ? (
          <>
            <div className="card-wrapper d-flex justify-content-center flex-wrap">
              <div className="result-card">
                <i className="icon-check" />
                <h5>{`${resultsSummarized?.correctAnswers?.value || '0'}/${
                  resultsSummarized?.totalQuestions || '0'
                }`}</h5>
                <p>CORRECT ANSWERS</p>
                <em>
                  +
                  {formatNumber(resultsSummarized?.correctAnswers?.points || 0)}{' '}
                  Points
                </em>
              </div>

              <div className="result-card">
                <i className="icon-pie_chart" />
                <h5>
                  {formatAccuracy(resultsSummarized?.accuracy?.value || 0)}%
                </h5>
                <p>ACCURACY</p>
                <em>
                  +{formatNumber(resultsSummarized?.accuracy?.points || 0)}{' '}
                  Points
                </em>
              </div>

              <div className="result-card">
                <i className="icon-clock" />
                <h5>
                  {formatTime(resultsSummarized?.timeElapsed?.value || '00:00')}
                </h5>
                <p>TIME ELAPSED</p>
                <em>
                  +{formatNumber(resultsSummarized?.timeElapsed?.points || 0)}{' '}
                  Points
                </em>
              </div>
            </div>
            <div className="card-wrapper d-flex justify-content-center mt-3">
              <Button
                onClick={this.exitQuiz}
                color="link"
                className="btn-outline-call-to-action mr-3"
              >
                EXIT QUIZ
              </Button>
              <Button onClick={this.reviewAnswers} color="primary">
                REVIEW ANSWERS
              </Button>
            </div>
          </>
        ) : null}
      </div>
    );
  }
}

export default Daily20Quiz;
